<template>

    <transition
        name="landing-transition"
        enter-active-class="animated slideInDown"
        leave-active-class="animated slideOutUp">

        <!-- LANDING -->
        <div class="landing" data-size="lg">

            <!-- CONTENT -->
            <div class="content" v-if="hasSupport">

                <h1 v-if="!has404">{{ landing.title }}</h1>
                <h2 v-if="!has404">{{ landing.tagline }}</h2>

                <h1 v-if="has404">{{ status.err404.title }}</h1>
                <h2 v-if="has404">{{ status.err404.msg }}</h2>

                <progress-button
                    :method="openSesame"
                    :loadingLabel="loadingLabel"
                    :readyLabel="buttonLabel"></progress-button>

            </div>
            <!-- END CONTENT -->

            <!-- ALT CONTENT -->
            <div class="content unsupported" v-else>

                <h1>{{unsupported.heading}}</h1>
                <div class="intro">{{unsupported.msg}}</div>

            </div>
            <!-- END ALT CONTENT -->

        </div>
        <!-- END LANDING -->

    </transition>

</template>


<script>

    import ProgressButton from "./ProgressButton.vue";

    let vm = {};

    export default{

        name: 'landing',

        components: {
            ProgressButton
        },

        data () {
            return {
                buttonLabel: 'Enter Experience',
                loadingLabel: 'Constructing Experience',
                unsupported: {
                    heading: 'Oops',
                    msg: 'It seems the browser you are using is incompatible with our website. Please update your browser to continue.'
                },
                status: {
                    err404: {
                        title: '404 - Page Not Found',
                        msg: 'The page you have requested cannot be found. Please check the URL in the address bar, or click back in your browser to return to your last location.'
                    }
                }
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            hasLoaded() {
                return this.$dataStore.getters.getLoadedState;
            },

            landing() {
                return this.$dataStore.getters.getLandingData;
            },

            hasSupport() {
                return Modernizr.canvas && Modernizr.flexbox && Modernizr.video;
            },

            has404() {
                return this.$dataStore.getters.get404Status;
            }

        },

        created() {},

        mounted() {
            vm = this;
        },

        methods: {

            /**
             * @method openSesame
             * @description
             */
            openSesame() {

                gtag('event', 'Enter Experience Click', {
                    'event_category': 'MBRe: Residential',
                    'event_label': ''
                });

                this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: !this.$dataStore.state.interactive.entered });
                this.$eventBus.$emit('residence:transition:in');
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/_variables.scss';

    .landing {
        height: 100%;
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        position: relative;
        transition: all 0.3s $easeInOutQuad;
    }

    .content {
        background-color: $white-100;
        height: 270px;
        padding: 50px 100px;
        box-shadow: 0 0 3px $black-20;
        position: relative;
        z-index: 5;
        align-self: center;
        transition: all 0.3s $easeInOutQuad;

        & h1 {
            font-family: $font-univers-light-cn;
            font-size: 2.188rem;
            line-height: 1;
            letter-spacing: 0.64px;
            color: var(--color-primary);
            text-transform: uppercase;
            margin: 0 0 16px 0;
        }

        & h2 {
            font-family: $font-univers-std;
            font-size: 1.25rem;
            line-height: 1.25;
            letter-spacing: 0;
            color: $base-text-color;
            margin: 0 10px 30px 10px;
        }

        & .intro {
            font-family: $font-univers-light;
            font-size: 0.938rem;
            line-height: 1.375;
            letter-spacing: 0.58px;
            color: $base-text-color;
            margin: 0 0 30px 0;
        }
    }

</style>

<style lang="scss">

    @import '../assets/styles/helpers/variables';

    .landing[data-size="lg"] {

        & .content {
            width: 100%;
            max-width: 640px;

            &.unsupported {

                & .intro {
                    margin: 0 0 0 0;
                }
            }

            & h2 {
                color: $base-text-color;
            }

            & .intro {
                color: $base-text-color;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// Landing.vue?094600e5